
import * as router from 'react-router-dom';

import { MagstimFetch, CurrentLang, SetLanguage,  } from "common"
import { ENUM_STATUS_ARCHIVED, ENUM_STATUS_PARENT_ARCHIVED, ENUM_USER_TYPE_ORGANISATION_ADMIN, ENUM_USER_TYPE_MAGSTIM_ADMIN } from "common/EnumConstants"

import {REST_ENDPOINT_CURRENT_USER} from 'common/ApiEndpoints';

//const ROLE_USER_MANAGEMENT = "0083d185-f142-4fb8-8cf6-2b3e02ec051c"; // obsolete
//const ROLE_SYSTEM_UPDATER = "06c641c0-6d64-48ec-9348-442a80368884"; // not needed in PDM

const ROLE_MANAGE_USERS_MAGSTIM_ADMIN = "e70d4927-1b0b-41ce-a157-33777f7d935d"; // Create/Edit Magstim Admin
const ROLE_MANAGE_USERS_ORGANISATION_ADMIN = "0cbf95bf-aa16-4de2-be78-710a0f915d88"; // Create/Edit Organisation Admin
const ROLE_MANAGE_USERS_ORGANISATION_USER = "7044fa65-d162-40b2-b2e0-4433e0b9cd18"; // Create/Edit Organisations users

const ROLE_MANAGE_CLINICS = "a3f3c2d8-bd49-423b-ab25-e89802f51c32"; // Create/Edit Clinics

const ROLE_MANAGE_ORGANISATIONS = "157c6ad7-71b1-4228-8815-4cd71baf4c12"; // Create/Edit Organisations

//const ROLE_MANAGE_TREATMENT_TEMPLATE = "f6e9fdcd-2c4e-4cec-b7d8-faff0c72d8b5"; // Create/Edit Treatment Templates
//const ROLE_RUN_TREATMENTS = "ec801301-6f6a-4cfc-8279-952d31f10baa"; // Run Treatments not needed in PDM

const USER_ENTERED_BASE_ROUTE = 'userEnteredBaseRoute_analytics';

class RouteManagerBase{

    constructor() {

        this.baseRoute = "";
        this.routesForCurrentUser = this.getAllRoutes();
        this.navigationItems = {items: []};
        this.OrganisationGuid = "";
        this.CurrentUserGuid = "";
        this.isOrganisationAdmin = false;
        this.isMagstimAdmin = false;

        this.getAllRoutes = this.getAllRoutes.bind(this);
        this.getNavigationItems = this.getNavigationItems.bind(this);
        this.getRoutesForCurrentUser = this.getRoutesForCurrentUser.bind(this);
        this.getBaseRoute = this.getBaseRoute.bind(this);
        this.clearUserEnteredBaseRoute = this.clearUserEnteredBaseRoute.bind(this);
        this.getRoutes = this.getRoutes.bind(this);
        this.getIsOrganisationAdmin = this.getIsOrganisationAdmin.bind(this);
        this.getIsMagstimAdmin = this.getIsMagstimAdmin.bind(this);
    }

    getNavigationItems(){
        return this.navigationItems;
    }

    getRoutesForCurrentUser(){
        return this.routesForCurrentUser;
    }

    getBaseRoute(){

        // Use the UserEnteredBaseRoute id it's set otherwise fall back to the normal base route
        var userBaseRoute = localStorage.getItem(USER_ENTERED_BASE_ROUTE);

        if(userBaseRoute !== undefined && userBaseRoute !== 'undefined' && userBaseRoute !== null){
            return userBaseRoute; 
        }

        return this.baseRoute;
    }

    // Clear the users entered route
    clearUserEnteredBaseRoute(){
        localStorage.setItem(USER_ENTERED_BASE_ROUTE, undefined);
    }

    setUserEnteredBaseRoute(userBaseRoute){

        // Check to see if this is a route we know about - so we ignore all callbacks etc. 
        var matchPath = router.matchPath;
        var route = this.getAllRoutes().find(function (route) {
            return matchPath(userBaseRoute.pathname, {
            path: route.path,
            exact: route.exact
            });
        });
    
        // If we do - then save it to local storage for when we reload
        if(route !== undefined && route.path !== undefined){
            localStorage.setItem(USER_ENTERED_BASE_ROUTE, userBaseRoute.pathname);
        }
    }

    getOrganisationGuid(){
        return this.OrganisationGuid;
    }

    getCurrentUserGuid(){
        return this.CurrentUserGuid;
    }

    getIsOrganisationAdmin(){
        return this.isOrganisationAdmin;
    }
    
    getIsMagstimAdmin(){
        return this.isMagstimAdmin;
    }

    getRoutes() {
        return new Promise((resolve, reject) => {
            MagstimFetch.get(REST_ENDPOINT_CURRENT_USER)
            .then((data) => {       

                if(data.Status === ENUM_STATUS_ARCHIVED){

                    // Archived - Magstim Admin to contact Magstim
                    if(data.UserType === ENUM_USER_TYPE_MAGSTIM_ADMIN){
                        throw(CurrentLang().pdm_account_archived_magstim); 
                    }

                    // Other users contact their adminstration 
                    throw(CurrentLang().pdm_account_archived);
                }

                if(data.Status === ENUM_STATUS_PARENT_ARCHIVED){

                    // Parent Archived - Magstim Admin and Org Admin to contact Magstim
                    if(data.UserType === ENUM_USER_TYPE_ORGANISATION_ADMIN || data.UserType === ENUM_USER_TYPE_MAGSTIM_ADMIN){
                        throw(CurrentLang().pdm_account_archived_magstim); 
                    }

                    // Other users contact their adminstration 
                    throw(CurrentLang().pdm_account_archived);
                }

                this.isMagstimAdmin = (data.UserType === ENUM_USER_TYPE_MAGSTIM_ADMIN);

                this.OrganisationGuid = data.OrganisationGuid;
                this.CurrentUserGuid = data.SystemUserGuid;

                // Need to set the language before we set the routes
                SetLanguage(data.Language, data.Locale);

                this.setRoutes(data.SystemUserRoles);
           
                resolve();
            })
            .catch((error) => {
                return reject(error)
            });
        });
      }



    // Test for any of the admin roles
    hasAdminRoles(systemUserRoles){
        if(systemUserRoles.includes(ROLE_MANAGE_ORGANISATIONS) ||
           systemUserRoles.includes(ROLE_MANAGE_USERS_MAGSTIM_ADMIN) ||
           systemUserRoles.includes(ROLE_MANAGE_USERS_ORGANISATION_ADMIN) ||
           systemUserRoles.includes(ROLE_MANAGE_CLINICS) ||
           systemUserRoles.includes(ROLE_MANAGE_USERS_ORGANISATION_USER)){
               return true;
           }

        return false;       
    }

   


}


export default RouteManagerBase